// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Link from "./Link.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Control from "./Control.bs.js";
import * as CloseIcon from "../icons/CloseIcon.bs.js";
import * as GithubIcon from "../icons/GithubIcon.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function Nav(Props) {
  var route = Props.route;
  var mobileNavShown = Props.mobileNavShown;
  var hideMobileNav = Props.hideMobileNav;
  return React.createElement("nav", {
              className: mobileNavShown ? "shown-mobile" : ""
            }, React.createElement("header", undefined, React.createElement("h1", {
                      onClick: (function (param) {
                          return RescriptReactRouter.push("/");
                        })
                    }, "rescript-dnd"), React.createElement("a", {
                      className: "github-link",
                      href: "https://github.com/shakacode/rescript-dnd"
                    }, React.createElement(GithubIcon.make, {})), React.createElement(Control.make, {
                      className: "close-button",
                      onClick: (function (param) {
                          return Curry._1(hideMobileNav, undefined);
                        }),
                      children: React.createElement(CloseIcon.make, {})
                    })), React.createElement(Link.make, {
                  path: "vertical-list",
                  active: route === /* VerticalList */0,
                  children: "Vertical list"
                }), React.createElement(Link.make, {
                  path: "horizontal-list",
                  active: route === /* HorizontalList */1,
                  children: "Horizontal list"
                }), React.createElement(Link.make, {
                  path: "vertical-scrollable-container",
                  active: route === /* VerticalScrollableContainer */2,
                  children: "Vertical scrollable container"
                }), React.createElement(Link.make, {
                  path: "horizontal-scrollable-container",
                  active: route === /* HorizontalScrollableContainer */3,
                  children: "Horizontal scrollable container"
                }), React.createElement(Link.make, {
                  path: "card-board",
                  active: route === /* CardBoard */4,
                  children: "Card board"
                }), React.createElement(Link.make, {
                  path: "nested-vertical-lists",
                  active: route === /* NestedVerticalLists */5,
                  children: "Nested vertical list"
                }));
}

var make = Nav;

export {
  make ,
  
}
/* Link Not a pure module */
